import CoursesPage from './CoursesPage';
import CourseFullView from './CourseFullView';
import ModuleView from './CourseModuleView';

export {
    CoursesPage,
    CourseFullView,
    ModuleView,
}


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/index.js